/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { Modal } from 'antd-mobile'
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react'
import SwiperCore, { Navigation, Pagination, EffectFade } from 'swiper'
import { AdvDialogStyle } from '@styles/modal'
import { isMobile } from 'react-device-detect'
import uuid from 'uuid'
// img
import BaccaratGuideImg01 from '@assets/images/casino/guide/baccarat-guide-01.png'
import BaccaratGuideImg02 from '@assets/images/casino/guide/baccarat-guide-02.png'
import BaccaratGuideImg03 from '@assets/images/casino/guide/baccarat-guide-03.png'

// css
import { ModalBg } from '@styles/base.style'
import { Button } from '@styles/button.style'
import { CarouselWrap } from '@views/Matchup/MatchUpBanner/index.style'
import { TutorialWrap } from '@views/Popup/Tutorial/index.style'


SwiperCore.use([Navigation, Pagination, EffectFade])

if (!isMobile) {
  SwiperCore.extendDefaults({ allowTouchMove: false })
}

const BaccaratGuidePopup: React.FC = () => {
  const { globalStore } = useRootStore()
  const { visibleBaccaratGuidePopup } = globalStore

  const list = [
    {
      tutorialImgUrl: BaccaratGuideImg01,
      closeBtn: false,
    },
    {
      tutorialImgUrl: BaccaratGuideImg02,
      closeBtn: false,
    },
    {
      tutorialImgUrl: BaccaratGuideImg03,
      closeBtn: false,
    },
  ]

  const onCloseModal = () => {
    globalStore.setVisibleBaccaratGuidePopup(false)
  }

  // 튜토리얼 이미지
  let slides = []
  slides = list.map((tutorial, index) =>
      <Fragment key={uuid.v4()}>
        <img key={`MatchUpBanner:Swiper:Slide:${String(index)}`} src={tutorial.tutorialImgUrl} alt="튜토리얼 이미지" className="img"/>
      </Fragment>
    ,
  )

  return (
    <Modal
      visible={visibleBaccaratGuidePopup}
      transparent
      maskClosable={false}
      onClose={onCloseModal}
      wrapClassName="tutorial"
      className="event"
      css={AdvDialogStyle}
    >
      <TutorialWrap className={!isMobile ? 'baccarat-guide baccarat-guide-pc': 'baccarat-guide'}>
        <Button TP className="cls-x-btn" onClick={onCloseModal}>
          <span className="x-ico"/>
        </Button>
        <CarouselWrap>
          <Swiper
            effect='fade'
            navigation={!isMobile}
            slidesPerView={1}
            speed={10}
            loop={false}
          >
            {slides.map((slideImg, index) => (
              <SwiperSlide key={`MatchUpBanner:Swiper:Slide:Item:${String(index)}`}>
                {slideImg}
              </SwiperSlide>
            ))}
          </Swiper>
        </CarouselWrap>
      </TutorialWrap>

      <ModalBg onClick={onCloseModal} className="clickable"/>
    </Modal>
  )
}

export default observer(BaccaratGuidePopup)
